import { Link, useLocation } from '@tanstack/react-router';
import { SCREENS } from '@/app/screens';
import { PageHeading } from '@/components/layout/PageHeading';
import { buttonVariants } from '@/components/ui/button';

/** Rendered inside the shell (and only for a signed-in user). */
export function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <div className="flex flex-1 items-center justify-center px-gutter py-16">
      <div className="flex flex-col items-center gap-3 text-center">
        <p className="num m-0 text-2xl font-semibold text-muted">404</p>
        <PageHeading visible>This page does not exist</PageHeading>
        <p className="ident m-0 break-all text-muted">{pathname}</p>
        <Link to={SCREENS.performance.path} className={buttonVariants({ variant: 'primary' })}>
          Back to {SCREENS.performance.title}
        </Link>
      </div>
    </div>
  );
}
